import { render, staticRenderFns } from "./profile-detail.vue?vue&type=template&id=8cee423c"
import script from "./profile-detail.vue?vue&type=script&lang=js"
export * from "./profile-detail.vue?vue&type=script&lang=js"
import style0 from "./profile-detail.vue?vue&type=style&index=0&id=8cee423c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./profile-detail.vue?vue&type=custom&index=0&blockType=graphql"
if (typeof block0 === 'function') block0(component)

export default component.exports